import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/habarana.jpg";

function Location() {

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[60vh] w-full">
                <img
                    src={aboutHero}
                    alt=""
                    className="absolute inset-0 w-full h-full object-fixed"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        Locations
                    </h1>
                </div>
            </section>

            {/* ================= LOCATION SECTION ================= */}
            <section className="py-20 bg-[#f8f6f3] px-4">
                <div className="max-w-6xl mx-auto text-center">

                    <p className="uppercase tracking-widest text-sm text-gray-500 mb-3">
                        Location
                    </p>

                    <h2
                        data-aos="fade-up"
                        className="text-3xl md:text-4xl font-semibold mb-6"
                    >
                        In the Heart of Habarana
                    </h2>

                    <p
                        data-aos="fade-up"
                        className="max-w-3xl mx-auto text-gray-600 mb-16"
                    >
                        Located in the peaceful surroundings of Habarana, our property offers
                        easy access to Sri Lanka’s Cultural Triangle including Sigiriya,
                        Dambulla, Minneriya National Park and Anuradhapura.
                    </p>

                    {/* Location Cards */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

                        {[
                            { name: "Habarana Town", distance: "2 km", time: "5 min" },
                            { name: "Sigiriya Rock", distance: "15 km", time: "20 min" },
                            { name: "Dambulla Cave Temple", distance: "25 km", time: "35 min" },
                            { name: "Minneriya National Park", distance: "18 km", time: "25 min" },
                            { name: "Anuradhapura", distance: "60 km", time: "1 hr 15 min" },
                        ].map((place, index) => (
                            <div
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 100}
                                className="bg-[#e9e2db] p-8 text-center shadow-sm hover:shadow-md transition"
                            >
                                <h3 className="text-lg font-semibold mb-3">
                                    {place.name}
                                </h3>

                                <div className="text-[#c97b3a] text-xl mb-3">
                                    • • •
                                </div>

                                <p className="font-medium">{place.distance}</p>
                                <p className="text-gray-600">{place.time}</p>
                            </div>
                        ))}
                    </div>

                    {/* Google Map */}
                    <div
                        data-aos="fade-up"
                        className="mt-20 rounded-lg overflow-hidden shadow-lg"
                    >
                        <iframe
                            title="Habarana Map"
                            src="https://www.google.com/maps?q=Habarana,Sri%20Lanka&output=embed"
                            width="100%"
                            height="450"
                            loading="lazy"
                            className="border-0"
                        ></iframe>
                    </div>

                </div>
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default Location;